import get from "lodash/get";
import React from "react";
import { useTranslation } from "react-i18next";
import { useRouteMatch } from "react-router-dom";

import AnnouncementForm from "~/components/Forms/AnnouncementForm";
import Preloader from "~/components/Preloader";
import Wrapper from "~/shared/ui/Wrapper";
import { useAnnouncement } from "~/pages/Announcement/hooks/useAnnouncement";
import { useAnnouncementGoBack } from "~/pages/Announcement/hooks/useAnnouncementGoBack";
import { useGetSubdivisionQuery } from "~/schemas/generated/graphql";

const AnnouncementEdit = () => {
  const { t } = useTranslation();
  const { params } = useRouteMatch();
  const goBack = useAnnouncementGoBack();
  const personalId = params["id"];
  const isAdd = personalId === "add";

  const subdivisionQuery = useGetSubdivisionQuery({
    variables: {
      page: 0,
      count: 1000,
    },
  });

  const {
    announcement: dataAnnouncement,
    loading: loadingAnnouncement,
    refetch: refetchAnnouncement,
  } = useAnnouncement(personalId, isAdd);

  const subdivisions = get(
    subdivisionQuery,
    "data.SubdivisionGetter.get.items",
    [],
  ).map(({ id, name }) => ({
    value: id,
    label: name,
  }));

  return (
    <Wrapper.Content
      title={t(
        `announcement.${isAdd ? "announcement_add" : "announcement_edit"}`,
      )}
      goBackHandler={goBack}
      txtBtn={"Назад"}
    >
      {isAdd ? (
        <AnnouncementForm subdivisions={subdivisions} />
      ) : loadingAnnouncement ? (
        <Preloader />
      ) : (
        <AnnouncementForm
          AnnouncementForm={dataAnnouncement}
          refetch={refetchAnnouncement}
          loading={loadingAnnouncement}
          subdivisions={[
            { value: null, label: t("employee.nothingSelected") },
            ...subdivisions,
          ]}
        />
      )}
    </Wrapper.Content>
  );
};

export default AnnouncementEdit;
